// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iMzXp":[function(require,module,exports,__globalThis) {
(function() {
    var relayoutTimer;
    function scheduleRelayout() {
        clearTimeout(relayoutTimer);
        relayoutTimer = setTimeout(layoutMasonry, 50);
    }
    function layoutMasonry() {
        document.querySelectorAll('[data-masonry]').forEach(function(el) {
            var container = el.querySelector('.facetwp-template') || el;
            var items = Array.from(container.children).filter(function(item) {
                return getComputedStyle(item).display !== 'none';
            });
            if (!items.length) return;
            container.setAttribute('aria-busy', 'true');
            var maxCols = parseInt(el.getAttribute('data-masonry')) || 4;
            var gapPreset = el.getAttribute('data-masonry-gap') || 'default';
            var w = window.innerWidth;
            var cols = 1;
            var gapX = 28;
            var gapY;
            if (gapPreset === 'compact') {
                if (w >= 1280) gapY = 48;
                else if (w >= 1024) gapY = 32;
                else if (w >= 768) gapY = 24;
                else gapY = 16;
            } else gapY = w >= 768 ? 64 : 36;
            if (w >= 1024) cols = maxCols;
            else if (w >= 768) cols = Math.min(2, maxCols);
            var containerWidth = container.offsetWidth;
            var colWidth = (containerWidth - gapX * (cols - 1)) / cols;
            var colHeights = [];
            for(var i = 0; i < cols; i++)colHeights.push(0);
            container.style.position = 'relative';
            items.forEach(function(item) {
                var minHeight = Math.min.apply(null, colHeights);
                var colIndex = colHeights.indexOf(minHeight);
                item.style.position = 'absolute';
                item.style.width = colWidth + 'px';
                item.style.left = colIndex * (colWidth + gapX) + 'px';
                item.style.top = colHeights[colIndex] + 'px';
                colHeights[colIndex] += item.offsetHeight + gapY;
                // Images that haven't loaded yet report a collapsed height, which
                // throws off the column heights above. Relayout once they arrive.
                item.querySelectorAll('img').forEach(function(img) {
                    if (!img.complete) {
                        img.addEventListener('load', scheduleRelayout, {
                            once: true
                        });
                        img.addEventListener('error', scheduleRelayout, {
                            once: true
                        });
                    }
                });
            });
            var maxHeight = Math.max.apply(null, colHeights);
            container.style.height = (maxHeight > 0 ? maxHeight - gapY : 0) + 'px';
            el.style.opacity = '1';
            container.style.opacity = '1';
            container.removeAttribute('aria-busy');
        });
    }
    var liveRegion;
    function announceResults() {
        var template = document.querySelector('.facetwp-template');
        if (!template) return;
        var count = template.children.length;
        var message = count === 0 ? 'No results found.' : count + (count === 1 ? ' result' : ' results') + ' shown.';
        if (!liveRegion) {
            liveRegion = document.createElement('div');
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            liveRegion.setAttribute('role', 'status');
            liveRegion.className = 'sr-only';
            document.body.appendChild(liveRegion);
        }
        liveRegion.textContent = message;
    }
    layoutMasonry();
    document.addEventListener('facetwp-loaded', function() {
        layoutMasonry();
        announceResults();
    });
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(layoutMasonry, 150);
    });
})();
// Registered on alpine:init (rather than assigned directly on window.Components)
// because the parent theme's components.js runs after this file and resets
// `window.Components = {}`, which would otherwise wipe this out.
(function() {
    document.addEventListener('alpine:init', function() {
        window.Components = window.Components || {};
        window.Components.searchModal = function searchModal() {
            return {
                __type: 'searchModal',
                open: false,
                init: function() {
                    this.$watch('open', function(open) {
                        document.body.classList.toggle('modal-active', open);
                    });
                },
                toggle: function() {
                    this.open = !this.open;
                },
                close: function() {
                    this.open = false;
                }
            };
        };
        // Single-artwork hero image lightbox/zoom. State + focus-trap wiring
        // lives here (per the searchModal convention above); the actual
        // wheel/drag/keyboard pan-zoom math lives in the block's own
        // content-single-artwork.js, which listens for the
        // 'artwork-lightbox:open' / 'artwork-lightbox:close' events dispatched
        // below to activate/reset itself.
        window.Components.artworkLightbox = function artworkLightbox() {
            return {
                __type: 'artworkLightbox',
                isOpen: false,
                triggerEl: null,
                init: function() {
                    var _this = this;
                    this.$watch('isOpen', function(isOpen) {
                        document.body.classList.toggle('modal-active', isOpen);
                        if (isOpen) _this.$dispatch('artwork-lightbox:open');
                        else {
                            _this.$dispatch('artwork-lightbox:close');
                            if (_this.triggerEl) _this.triggerEl.focus();
                        }
                    });
                },
                open: function(triggerEl) {
                    this.triggerEl = triggerEl;
                    // Note: can't use this.$el here — $el is scoped to whichever
                    // element's directive is currently evaluating (the trigger
                    // button), not the x-data root, so a querySelector from it
                    // would miss the dialog's img entirely. $refs is scoped to
                    // the whole component regardless of which element invoked us.
                    var img = this.$refs.lightboxImage;
                    if (img) {
                        img.src = triggerEl.getAttribute('data-lightbox-src') || '';
                        img.alt = triggerEl.getAttribute('data-lightbox-alt') || '';
                    }
                    this.isOpen = true;
                },
                close: function() {
                    this.isOpen = false;
                }
            };
        };
    });
})();

},{}]},["iMzXp"], "iMzXp", "parcelRequired6e5", {})

//# sourceMappingURL=child.js.map
